import { UnitSelect as AntdUnitSelect } from "@empglabs/backoffice-ui-kit"

const UnitSelect = props => {
  return <AntdUnitSelect {...props} />
}

export default UnitSelect
